import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { ReactComponent as Logo } from '../../../assets/images/logo.svg';

const Footer = () => {
  return (
    <footer className="ftco-footer ftco-section footer--blue">
      <div className="container">
        <div className="row mb-5">
          <div className="col-md">
            <div className="ftco-footer-widget mb-4">
              <Link className="navbar-brand" to="/">
                <Logo className="footer-logo" role="img" aria-label="Nest Auto Transport logo" />
              </Link>
              <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-5">
                <li className="ftco-animate">
                  <h2 className="ftco-heading-2 footer-dot-mc">DOT : 4473900</h2>
                </li>
                <br/>
                <li className="ftco-animate">
                  <h2 className="ftco-heading-2 footer-dot-mc">MC&nbsp;&nbsp;: 1766069</h2>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md">
            <div className="ftco-footer-widget mb-4">
              <h2 className="ftco-heading-2">About NEST Auto Transport</h2>
              <p>At NEST Auto Transport, we are dedicated to providing reliable, efficient, and hassle-free vehicle shipping services across the nation.</p>
            </div>
          </div>
          <div className="col-md">
            <div className="ftco-footer-widget mb-4 ml-md-5">
              <h2 className="ftco-heading-2">Information</h2>
              <ul className="list-unstyled">
                <li><Link to="/about" className="py-2 d-block">About</Link></li>
                <li><Link to="/faq" className="py-2 d-block">FAQ</Link></li>
                <li><Link to="/contact" className="py-2 d-block">Contact Us</Link></li>
                <li><Link to="/privacy-policy" className="py-2 d-block">Privacy Policy</Link></li>
                <li><Link to="/terms-conditions" className="py-2 d-block">Term & Conditions</Link></li>
              </ul>
            </div>
          </div>
          <div className="col-md">
            <div className="ftco-footer-widget mb-4">
              <h2 className="ftco-heading-2">Have a Questions?</h2>
              <div className="block-23 mb-3">
                <ul>
                  <li>
                    <span className="icon icon-map-marker"></span>
                    <span className="text">Nest Auto Transport Inc.<br/> 13151 Emily Rd Suite # 210-D Dallas TX 75240</span>
                  </li>
                  <li>
                    <span className="icon icon-phone"></span>
                    <span className="text">+1 (888) 512-NEST</span>
                  </li>
                  <li>
                    <span className="icon icon-envelope footer-email-icon"></span>
                    <span className="text">info@nestautotransport.com</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-md-12 text-center">
            <div className="footer-social-icons">
              <a href="https://www.facebook.com/profile.php?id=61582615372295" target="_blank" rel="noopener noreferrer" className="social-icon facebook" title="Visit our Facebook page">
                <span className="icon icon-facebook"></span>
              </a>
              <a href="https://www.linkedin.com/company/nest-auto-transport" target="_blank" rel="noopener noreferrer" className="social-icon linkedin" title="Visit our LinkedIn page">
                <span className="icon icon-linkedin"></span>
              </a>
              <a href="https://www.google.com/search?q=NEST+Auto+Transport" target="_blank" rel="noopener noreferrer" className="social-icon google" title="Visit our Google profile and reviews">
                <span className="icon icon-google"></span>
              </a>
              <a href="https://instagram.com/nestautotransport" target="_blank" rel="noopener noreferrer" className="social-icon instagram" title="Visit our Instagram page">
                <span className="icon icon-instagram"></span>
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 text-center">
            <p>© 2026 Nest Auto Transport. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


